import fetchWrapper from '@CustomerPage/services/fetch_wrapper'

const UPDATE_WISHLIST_MUTATION = `
  mutation updateWishlist($input: UpdateWishlistInput!) {
  updateWishlist(input: $input) {
    error
    variantExternalIds
    inWishlist
    productId
    productTitle
    productPrice
    guestId
    list
  }
}
`

const SYNC_GUEST_WISHLIST_MUTATION = `
  mutation syncGuestWishlist($input: SyncGuestWishlistInput!) {
  syncGuestWishlist(input: $input) {
    error
  }
}
`

const ADD_TO_CART_WISHLIST_MUTATION = `
  mutation addToCartWishlist($input: AddToCartWishlistInput!) {
  addToCartWishlist(input: $input) {
    error
  }
}
`

const DELETE_MUTATION = `
  mutation updateWishlist($input: UpdateWishlistInput!) {
  updateWishlist(input: $input) {
    error
  }
}
`

const CREATE_WISHLIST_LIST_MUTATION = `
  mutation createWishlistList($input: CreateWishlistListInput!) {
  createWishlistList(input: $input) {
    error
    list
  }
}
`

const ACTIVATE_WISHLIST_LIST_MUTATION = `
  mutation activateWishlistList($input: ActivateWishlistListInput!) {
  activateWishlistList(input: $input) {
    error
    list
  }
}
`

const DELETE_WISHLIST_LIST_MUTATION = `
  mutation deleteWishlistList($input: DeleteWishlistListInput!) {
  deleteWishlistList(input: $input) {
    error
    list
  }
}
`

const EDIT_WISHLIST_LIST_MUTATION = `
  mutation editWishlistList($input: EditWishlistListInput!) {
  editWishlistList(input: $input) {
    error
    newList
    oldList
  }
}
`

const APP_PROXI_URL = `${Shopify && Shopify.routes && Shopify.routes.root || '/'}${window.frcp.appProxy}/api/graphql`.replace('//', '/')
const APP_URL = `${window.frcp.httpsUrl}/api/graphql`
export default {
  updateWishlist(input, successCallback, errorCallback) {
    return this.request({ input, query: UPDATE_WISHLIST_MUTATION, queryName: 'updateWishlist', successCallback, errorCallback })
  },

  syncGuestWishlist(input, successCallback, errorCallback) {
    return this.request({ input, query: SYNC_GUEST_WISHLIST_MUTATION, queryName: 'syncGuestWishlist', successCallback, errorCallback })
  },

  sendAddToCartWishlistRequest(input, successCallback, errorCallback) {
    return this.request({ input, query: ADD_TO_CART_WISHLIST_MUTATION, queryName: 'addToCartWishlist', successCallback, errorCallback })
  },

  sentRequestToDeleteWishlistItem(input, successCallback, errorCallback) {
    return this.request({ input, query: DELETE_MUTATION, queryName: 'updateWishlist', successCallback, errorCallback })
  },

  sendCreateWihslistListRequest(input, successCallback, errorCallback) {
    return this.request({ input, query: CREATE_WISHLIST_LIST_MUTATION, queryName: 'createWishlistList', successCallback, errorCallback })
  },

  sendActivateWishlistListRequest(input, successCallback, errorCallback) {
    return this.request({ input, query: ACTIVATE_WISHLIST_LIST_MUTATION, queryName: 'activateWishlistList', successCallback, errorCallback })
  },

  sendDeleteWishlistListRequest(input, successCallback, errorCallback) {
    return this.request({ input, query: DELETE_WISHLIST_LIST_MUTATION, queryName: 'deleteWishlistList', successCallback, errorCallback })
  },

  sendEditWishlistListRequest(input, successCallback, errorCallback) {
    return this.request({ input, query: EDIT_WISHLIST_LIST_MUTATION, queryName: 'editWishlistList', successCallback, errorCallback })
  },

  request({ input, query, queryName, successCallback, errorCallback }) {
    const url = window.frcp.useAppProxi ? APP_PROXI_URL : APP_URL
    
    const externalId = input.customerExternalId
    const froonzeToken = input.froonzeToken
    delete input.customerExternalId
    delete input.froonzeToken
    
    const body = {
      query: query,
      variables: { input: input },
    }

    const headers = {
      'x-shop-domain': window.frcp.shopDomain,
      'x-shop-token': window.frcp.shopToken,
      'Access-Control-Allow-Origin': '*',
    }

    if (externalId && froonzeToken) {
      headers['x-customer-id'] = externalId
      headers['x-froonze-token'] = froonzeToken
    }

    return fetchWrapper.jsonClient(url, {
      method: 'POST',
      body,
      headers
    })
      .then(response => {
        if (response.data[queryName].error) {
          console.log(response.data[queryName].error)
          if (errorCallback) errorCallback(response.data[queryName].error)
          return
        }
        if (successCallback) successCallback(response)
      }).catch(error => {
        console.log(error)
        if (errorCallback) errorCallback(error)
      })
  },
}
